import { serviceInstance as api } from "../service";

export const getDataMaster = async (params) => {
  const queryParams = new URLSearchParams({
    Usuario: params.Usuario,
  }).toString();

  const response = await api().get(
    `/maestros${!!queryParams ? "?" + queryParams : ""}`
  );
  
  return response.data.result.data;
};
